import * as React from 'react';
import { FlightsSearchFormTravelersOption } from 'types/search/wizard/flights-search-form-option';
import { flightsMultiPluralLocalizationTemplate } from 'utility';

export interface TravelerProps {
  travelerTypeOptions: FlightsSearchFormTravelersOption;
}

export const TravelerCountInfo = ({ travelerTypeOptions }: TravelerProps) => {
  const travelerItems = travelerTypeOptions && travelerTypeOptions.items;
  const replacerStr = '{numberOfTravelers}';
  let count = 0;
  travelerItems.filter(item => item.travelerCount !== 0).map(item => (count = count + item.travelerCount));

  return (
    <span className="all-l-margin-one">
      &middot; {flightsMultiPluralLocalizationTemplate(count, travelerTypeOptions.valueTemplate, replacerStr)}
    </span>
  );
};
